<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_alert_modal">
            <div class="modal-content" data-cy="container_alert_modal_content">
                <div class="bg-white w-full rounded-xl p-3" data-cy="container_alert_modal_body">
                    <div class="text-center text-xl pt-3 font-bold font-main-bold" v-html="title" data-cy="text_alert_modal_title"></div>
                    <div class="text-center text-lg pb-5 pt-3 font-medium font-main-medium" v-html="message" data-cy="text_alert_modal_message"></div>
                    <div class="w-1/2 m-auto" data-cy="container_alert_modal_btn_wrap">
                        <button class="w-full bg-gold text-dark-3 rounded-md py-1 px-2 font-medium text-sm capitalize font-main-medium" @click="clickOk()" data-cy="btn_alert_modal_ok">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_alert_modal_backdrop"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
